import { useState } from "react"
import { GetMobileOperatingSystem } from "../../../Utils/getOS"
import { postLogDetails } from "../../../Services/APIs/appDetails"
import teethSides from "../../../Utils/teethSideNames"
import back from "../../../assets/Icons/Back.png"
import demoIcon from "../../../assets/Icons/image-reference.png"
import { steps } from "./steps"
// import { getCameraPermission } from "../../../Utils/getCameraPermission"
import DemoScreens from "./demoscreens"
import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import { GetBrowserDetails } from "../../../Utils/deviceDetails"
import "../../../App.css"
import "../../PeriGumCheck/Scan/index.css"
import signalAILogo from "../../../assets/illustrations/signal-AI.png"
import Preview from "./preview"




const Capture = (props) => {
    const { activeImageSide, setImageSide } = props
    const [facialMode, setFacialMode] = useState(FACING_MODES.USER)
    const [frontCameraError, setFrontCameraError] = useState(false)
    const [isDemo, setDemo] = useState(true)
    const [isCamera, setCamera] = useState(true)
    const [capturedImage, setCapturedImage] = useState()
    const [mediaStream, setStream] = useState(null)
    const OS = GetMobileOperatingSystem()   // operating system
    const [errorType, setErrorType] = useState({ isError: false, type: "ios" })
    const uid = JSON.parse(localStorage.getItem("usertpi") || '{}').usertpi
    const app = JSON.parse(localStorage.getItem("companyBucket") || "{}").companyBucket


    const cameraStarted = (stream) => {
        setStream(stream)
        handleCameraType()
        setErrorType({ isError: false, type: "ios" })
    }

    const handleCameraType = () => {
        OS === "iOS" ? handleWithFacialMode() : handleWithLabel()
    }

    const handleWithFacialMode = () => {
        navigator.mediaDevices.getUserMedia({ video: { facingMode: FACING_MODES.USER } })
            .then((stream) => {
                setFacialMode(FACING_MODES.USER)
                postLogDetails({ uid, app, payLoad: `iOS - found front camera, video-track-length-${stream.getVideoTracks().length}` })
            })
            .catch((error) => {
                postLogDetails({ uid, app, payLoad: `ios- front camera error  ${JSON.stringify(error)} so starting rear-camera` })
                // notifyCameraError({ info: { ...getCompleteDeviceDetails(), uid, app, error: JSON.stringify(error) } })
                setFrontCameraError(true)
                setFacialMode(FACING_MODES.ENVIRONMENT)
            });
    }

    const handleWithLabel = () => {
        navigator.mediaDevices.enumerateDevices()
            .then(devices => {
                const videoDevices = devices.filter(device => device.kind === 'videoinput');
                const frontCamera = videoDevices.find(device => device.getCapabilities().facingMode?.includes("user"));
                if (frontCamera) {
                    setFacialMode(frontCamera.deviceId); // Set the deviceId directly
                    postLogDetails({ uid, app, payLoad: "Android - found front camera" })

                } else {
                    postLogDetails({ uid, app, payLoad: `Android- front camera error  ${JSON.stringify(videoDevices)} so starting rear-camera` })
                    // notifyCameraError({ info: { ...getCompleteDeviceDetails(), uid, app, error: JSON.stringify(videoDevices) } })
                    setFacialMode(FACING_MODES.ENVIRONMENT); // Fallback to rear camera
                    setFrontCameraError(true)
                }
            })
            .catch(err => {
                postLogDetails({ uid, app, payLoad: `Android- media devices error ${JSON.stringify(err)}` })
            });
    }


    const handleTakePhoto = (dataUri) => {
        const base64String = dataUri.split(',')[1]; // Remove the data URI scheme part
        const base64StringLength = base64String.length;
        const estimatedSizeInBytes = (base64StringLength * 3) / 4; // Base64 size formula
        const estimatedSizeInKB = estimatedSizeInBytes / 1024; // Convert to KB
        const estimatedSizeInMB = estimatedSizeInKB / 1024; // Convert to MB
        setCapturedImage(dataUri)
        postLogDetails({
            uid: JSON.parse(localStorage.getItem("usertpi")).usertpi,
            app: JSON.parse(localStorage.getItem("companyBucket")).companyBucket,
            payLoad: `captured ${teethSides[activeImageSide]} teeth, ${estimatedSizeInMB.toFixed(5)} MB`,
        })
        setTimeout(() => {
            setCamera(false)
        }, 100)
        stopCamera();
    }



    const OvuleShape = () => {
        return (
            <div className={`ovule-container w-full flex flex-col justify-center items-center `}>
                {/* <img src={signalAILogo} alt="signal-ai-logo" className="w-24 h-24" />
                <p className="text-white text-lg font-semibold pb-10">{teethSides[activeImageSide]}</p> */}
                <div className={`relative signal-ai-ovule ovule-${activeImageSide} ${activeImageSide === 4 && isCamera && "ovule-4-reversed"}  `}>
                </div>
            </div>
        )
    }

    const TopLayer = () => {
        return (
            <div className=' flex flex-col items-center camera-top-layer-2 h-full absolute top-0 text-white w-full'>

                <img src={signalAILogo} alt="signal-ai-logo" className={` w-2/5 mx-auto mt-4 ${activeImageSide === 4 && isCamera && "ransform rotate-180"}`} />

                <p
                    className={` text-center text-4xl text-white font-medium -mt-2 ${activeImageSide === 4 && isCamera && "ransform rotate-180 "}`}
                >
                    {steps[activeImageSide].label}



                </p>

                <p className={` mx-10 absolute bottom-[12%] text-white text-left ${activeImageSide === 4 && isCamera && "ransform rotate-180"}`}>
                    ပုံတွင်ပြထားတဲ့အတိုင်းသင့်သွားကိုအကွက်အတွင်းထဲထားပြီး ဖုန်းစခရင်ကိုတစ်ချက်နှိပ်ပြီး ပုံရိုက်ပါ။

                </p>

            </div>
        )
    }
    const checkError = () => {
        const browser = GetBrowserDetails();

        if (browser.name === "Mobile Chrome") {
            navigator.permissions.query({ name: 'camera' }).then((res) => {
                if (res.state === "denied") {
                    if (OS === 'iOS') {
                        setErrorType({ isError: true, type: "ios" })
                    } else {
                        setErrorType({ isError: true, type: "android" })
                    }
                }
            }).catch((error) => {
                setErrorType({ isError: true, type: "ios" })
            })

        } else {
            setErrorType({ isError: true, type: "ios" })
        }

    }

    const stopCamera = () => {
        // console.log("Tracks before stopping:", mediaStream.getTracks()); // Log tracks
        if (mediaStream) {
            mediaStream.getTracks().forEach((track) => {
                // console.log(`Stopping track with kind: ${track.kind}, readyState: ${track.readyState}`);
                postLogDetails({ uid, app, payLoad: `Stopping track with kind: ${track.kind}, readyState: ${track.readyState}` })
                track.stop()
                // console.log(`Track stopped. New readyState: ${track.readyState}`);
                postLogDetails({ uid, app, payLoad: `Track stopped ${track.kind}, readyState: ${track.readyState}` })
            });
            setStream(null);
        }
    };

    console.log("activeImageSide", props);

    return (
        <div className="h-full w-full">
            {
                isDemo ? <DemoScreens activeImageSide={activeImageSide} setDemo={setDemo} setCamera={setCamera} /> :
                    <div className="h-full w-full">
                        {/* {errorType.isError && <PermissionPopup info={errorType} setErrorType={setErrorType} />} */}

                        {isCamera ?
                            <div className='h-full relative'>
                                <Camera
                                    onTakePhoto={(dataUri) => { handleTakePhoto(dataUri); }}
                                    idealFacingMode={facialMode} // Set back camera preference
                                    isFullscreen={false}
                                    isMaxResolution={true}
                                    imageType={IMAGE_TYPES.JPG}
                                    imageCompression={0.9}
                                    sizeFactor={1}
                                    videoConstraints={{
                                        facingMode: { exact: "user" }, // Force front camera
                                        width: { ideal: window.innerWidth },
                                        height: { ideal: window.innerHeight },
                                        aspectRatio: { ideal: window.innerWidth / window.innerHeight }
                                    }}
                                    isImageMirror={facialMode !== FACING_MODES.ENVIRONMENT}
                                    onCameraStart={cameraStarted}
                                    onCameraError={checkError}
                                    className="WebCam"
                                />
                                {/* {!errorType.isError && frontCameraError && <FrontCameraError back={setFrontCameraError} />} */}

                            </div> :
                            <Preview
                                setImageSide={setImageSide}
                                image={capturedImage}
                                setCamera={setCamera}
                                activeImageSide={activeImageSide}
                                setDemo={setDemo} />
                        }
                        <>
                            <OvuleShape />
                            <TopLayer />
                        </>


                    </div>
            }
        </div>
    )
}

export default Capture